/* src/app/modules/agent/pages/property-list/components/export-property-leads/export-property-leads.component.scss */
.dialog-title {
  font-size: 22px;
  margin: 0;
}
.hint-text {
  font-size: 12px;
  color: #555;
  margin-top: 0;
}
.file-box {
  border: 1.5px dashed var(--ion-color-medium);
  border-radius: 10px;
  padding: 18px 14px;
  text-align: center;
  background: #fafafa;
  transition: border-color 0.2s;
}
.file-box.invalid {
  border-color: #e53935;
}
.file-box .placeholder {
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
}
.file-box .placeholder p {
  margin: 0;
  font-size: 12px;
  color: #666;
}
.file-box .upload-icon {
  font-size: 36px;
  color: var(--ion-color-primary);
}
.file-box .selected-file {
  display: flex;
  align-items: center;
  gap: 12px;
  text-align: left;
}
.file-box .selected-file .file-icon {
  font-size: 36px;
  color: var(--ion-color-primary);
}
.file-box .selected-file .meta {
  flex: 1;
}
.file-box .selected-file .meta small {
  display: block;
  color: #777;
  margin-top: 2px;
}
.progress-wrapper {
  margin-top: 14px;
}
.actions-inline {
  display: flex;
  gap: 8px;
  margin-top: 12px;
  flex-wrap: wrap;
}
.import-button {
  --box-shadow: none !important;
}
.mat-mdc-raised-button:not(:disabled) {
  background-color: var(--ion-color-secondary-shade) !important;
  color: white;
  box-shadow: none !important;
}
.date-range-form {
  margin-top: 30px;
}
/*# sourceMappingURL=export-property-leads.component.css.map */
